import * as React from 'react';
import { AppTeachingBubbleProps } from "./AppTeachingBubble.props";
import { TeachingBubble } from 'office-ui-fabric-react';
import type { ITeachingBubbleProps } from 'office-ui-fabric-react';

const TeachingBubbleWithChildren = TeachingBubble as React.FunctionComponent<React.PropsWithChildren<ITeachingBubbleProps>>

/**
 * Teaching Bubble
 * @param props Teaching bubble component properties
 */
export const AppTeachingBubble: React.FunctionComponent<AppTeachingBubbleProps> = (props: AppTeachingBubbleProps): JSX.Element => {
    const { target, calloutProps, hasCloseButton, hasCloseIcon, hasSmallHeadline,
        headline, isWide, onDismiss, primaryButtonProps,
        secondaryButtonProps, text, styles, focusTrapZoneProps, closeButtonAriaLabel } = props;

    return (
    <TeachingBubbleWithChildren
        target = {target}
        calloutProps = {calloutProps}
        hasCloseButton = {hasCloseButton}
        closeButtonAriaLabel = {closeButtonAriaLabel}
        hasCloseIcon = {hasCloseIcon}
        hasSmallHeadline = {hasSmallHeadline}
        headline = {headline}
        isWide = {isWide}
        onDismiss = {onDismiss}
        primaryButtonProps={primaryButtonProps}
        secondaryButtonProps={secondaryButtonProps}
        focusTrapZoneProps={focusTrapZoneProps}
        styles = {styles}
      >{text}</TeachingBubbleWithChildren>
      );
}